import { toIcons, toIllustrations } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import { getSocialName } from "../../utils/getMethods";

const Contacts = (props: any) => {
  const { isMobile } = useIsMobile();
  return (
    <div
      className="contacts"
      style={{
        margin: isMobile ? "0 16px" : "",
        height: isMobile ? "fit-content" : "",
      }}
    >
      <p className="contacts-title">Contacts</p>
      <div className="info-spec">
        <p className="info-spec-field">Agency</p>
        <p className="info-spec-value">{props.model?.contacts.agency}</p>
      </div>
      <div className="info-spec">
        <p className="info-spec-field">Phone</p>
        <p className="info-spec-value">{props.model?.contacts.phone}</p>
      </div>
      <div className="info-spec">
        <p className="info-spec-field">E-mail</p>
        <p className="info-spec-value">{props.model?.contacts.mail}</p>
      </div>
      <div className="info-spec" style={{ gap: "10px" }}>
        <p className="info-spec-field">Social</p>
        {props.model?.contacts?.socials?.instagram?.link && (
          <div className="info-social-box">
            <span className="info-social-link-box">
              <div>
                <img
                  className="info-social-img"
                  src={`${toIllustrations}/instagram.svg`}
                />
              </div>
              <a
                href={props.model?.contacts.socials.instagram.link}
                className="info-social-profileLink"
              >
                {getSocialName(props.model?.contacts.socials.instagram.link)}
              </a>
            </span>
            {/* <p className="info-social-followers">
            {props.model?.contacts.socials.instagram.followers}K
          </p> */}
          </div>
        )}
        {props.model?.contacts?.socials?.tiktok?.link && (
          <div className="info-social-box">
            <span className="info-social-link-box">
              <div>
                <img
                  className="info-social-img"
                  src={`${toIllustrations}/tiktok.svg`}
                />
              </div>
              <a
                href={props.model?.contacts.socials.tiktok.link}
                className="info-social-profileLink"
              >
                {getSocialName(props.model?.contacts.socials.tiktok.link)}
              </a>
            </span>
            {/*  <p className="info-social-followers">
            {props.model?.contacts.socials.tiktok.followers}K
          </p> */}
          </div>
        )}
        {props.model?.contacts?.socials?.facebook?.link && (
          <div className="info-social-box">
            <span className="info-social-link-box">
              <div>
                <img
                  className="info-social-img"
                  src={`${toIllustrations}/facebook.svg`}
                />
              </div>
              <p className="info-social-profileLink">
                {getSocialName(props.model?.contacts.socials.facebook.link)}
              </p>
            </span>
            {/*  <p className="info-social-followers">
            {props.model?.contacts.socials.facebook.followers}K
          </p> */}
          </div>
        )}
      </div>
    </div>
  );
};
export default Contacts;
